module.exports = __webpack_public_path__ + "static/media/FFEP_230127.f591b58c.jpg";